// extracted by mini-css-extract-plugin
export default {"content":"BulkEditForm_content__3EWvW","dropdown":"BulkEditForm_dropdown__FR4Vd","form":"BulkEditForm_form__3zxax","description":"BulkEditForm_description__FAqmP"};